<template>
  <div>
    <div class="vx-row">
      <div class="vx-col sm:w-1/1 w-full mb-2">
        <vx-card title="Description">
          <p class="mb-5">Setup Quiz</p>

          <div class="vx-row">
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <v-select @change="alert('working')" :options="data.subject" v-model="subject" label="label" placeholder="Select Class Subject"  />
            </div>
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <v-select :options="data.type" v-model="group.type" placeholder="Select Quiz Type"  />
            </div>
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <v-select :options="data.duration" v-model="group.duration" placeholder="Select Task Duration"  />
            </div>
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <vs-input v-model="group.title" class="w-full" placeholder="Title"  />
            </div>
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <flat-pickr :config="configdateDueTimePicker" class="w-full h-15" v-model="group.duedate" placeholder="Submission / Due Date" />
            </div>
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <div>
                <vs-textarea v-model="group.instructions" label="Quiz Instructions" rows="1" />
              </div>
            </div>
          </div>


          <div v-show="subject">
            <p class="mb-5">Specify Classes taking this lesson</p>

            <div class="vx-row ml-0 mr-0" v-show="subject && subject.subj_id == key" v-for="(value, key) in data.classes" :key="key">
              <div class="vx-col  w-full mb-2" v-for="(val, ky) in value" :key="ky">
                <span v-if="subject && ky == subject.rank.toString().slice(0, 2)"> 
                  <ul v-for="(v, k) in val" :key="k">
                    <li>
                      <vs-checkbox :vs-value="v.class_id" v-model="group.class">{{ v.class }}</vs-checkbox>
                    </li>
                  </ul>
                </span>
                <!-- <span v-else> 
                  <ul v-for="(v, k) in val" :key="k">
                    <li style="color: grey">
                      <vs-checkbox :disabled="true" :vs-value="v.class_id" v-model="group.class">{{ v.class }}</vs-checkbox>
                    </li>
                  </ul>
                </span> -->
              </div>
            </div>
          </div>

        </vx-card>
      </div>
    </div>

    <br>

    <div class="vx-row">
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <vx-card :title="(subject) ? subject.label : 'Subject'">

          <vs-row vs-w="12">
            <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
              {{ (group.type) ? group.type.label : 'Type' }}
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
              {{ checkedCount }} Questions
            </vs-col>
            <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="4">
              {{ (group.duration) ? group.duration.label : 'Time' }}
            </vs-col>
          </vs-row>


          <p v-if="!(data.questions[0])" class="text-center">
            Select Questions from Bank.
          </p>

          <br>

          <!-- <div v-if="group.instructions">
            <hr>
            <br>
            <i>{{ group.instructions }}</i>
            <br><br>
            <hr>
          </div> -->

          <div class="vx-row">
            <div class="vx-col sm:w-1/1 w-full mb-2" v-for="(q, index) in checkedQuestion" :key="index">
              <vx-card class="question" v-bind:class="{ choseQuestion: (checkedQuestion[q.id]) }">
                <div>
                  <p class="md-5">
                    <b>{{ q.body }}</b>
                  </p>
                  <div v-if="q.type === 'multipleopt'">
                    <ul class="optionlist2 ml-5">
                      <li v-for="(v, indexv) in q.typeOption" :key="indexv">
                        {{ v }}
                      </li>
                    </ul>
                  </div>
                  <div v-if="q.type === 'multiplesel'">
                    <ul class="optionlist2 ml-5">
                      <li v-for="(v, indexv) in q.typeOption" :key="indexv">
                        {{ v }}
                      </li>
                    </ul>
                  </div>
                </div>

                <vs-row vs-w="12" class="mt-3">
                  <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="8">
                    <vs-input v-model="checkedMarks[q.id]" placeholder="Weighted Mark" type="tel" class="mr-3" /> Mark
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="4">
                    <vs-button radius color="danger" type="border" icon-pack="feather" icon="icon-trash-2" v-on:click="selectQuestion(q)"></vs-button>
                  </vs-col>
                </vs-row>
                
              </vx-card>
              <br>
            </div>
          </div>

          <div class="vx-col w-full">
            <vs-button class="mr-3 mb-2" @click="saveQuiz">Save</vs-button>
          </div>
        </vx-card>
      </div>

      
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <vx-card title="Question Bank">

          <p v-if="!(data.questions[0])" class="text-center">
            Select a subject to show Questions.
          </p>

          <div class="vx-col sm:w-1/1 w-full mb-2" v-for="(q, index) in data.questions" :key="index">
            <vx-card class="question" v-bind:class="{ selectedQuestion: (checkedQuestion[q.id]) }" v-on:click="selectQuestion(q)">
              <div>
                <p class="md-5">
                  <b>{{ q.body }}</b>
                </p>
                <div v-if="q.type === 'multipleopt'">
                  <ul class="optionlist2 ml-5">
                    <li v-for="(v, indexv) in q.typeOption" :key="indexv">
                      {{ v }}
                    </li>
                  </ul>
                </div>
                <div v-if="q.type === 'multiplesel'">
                  <ul class="optionlist2 ml-5">
                    <li v-for="(v, indexv) in q.typeOption" :key="indexv">
                      {{ v }}
                    </li>
                  </ul>
                </div>
              </div>
              
            </vx-card>
            <br>
          </div>

        </vx-card>
      </div>
      
    </div>

  </div>
</template>

<script>
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

import { quillEditor } from 'vue-quill-editor'
import Prism from 'vue-prism-component'

export default {
  data () {
    return {
      configdateDueTimePicker: {
        enableTime: true,
        dateFormat: 'd-m-Y H:i'
      },
      subject: null,
      checkedQuestion: {},
      checkedMarks: {},
      checkedCount: 0,
      group: {
        subject: null,
        category: null,
        title:null,
        duration: null,
        instructions: null,
        type: null,
        duedate: null,
        class: []
      },
      data: {
        question: '',
        optionType: null,
        subject: [],
        classes: [],
        category: [],
        questions: [],
        duration: [
          { duration: 0, label: 'No Timing' },
          { duration: 15, label: '15 minutes' },
          { duration: 30, label: '30 minutes' },
          { duration: 45, label: '45 minutes' },
          { duration: 60, label: '1 hour' },
          { duration: 90, label: '1 hours, 30 mins' },
          { duration: 120, label: '2 hours' },
          { duration: 180, label: '3 hours' },
          { duration: 1440, label: '1 day' },
          { duration: 2880, label: '2 days' },
          { duration: 10080, label: '1 week' }
        ],
        type: [
          { type: 'classwork', label: 'Classwork' },
          { type: 'assignment', label: 'Assignment' },
          { type: 'test', label: 'Test' },
          { type: 'exam', label: 'Exam' }
        ],
        control: {
          check: {
            final: {
              a1: null,
              a2: null,
              a3: null,
              a4: null,
              a5: null
            },
            options: {
              v1: null,
              v2: null,
              v3: null,
              v4: null,
              v5: null
            }
          },
          radio: {
            final: {
              a1: null
            },
            options: {
              v1: null,
              v2: null,
              v3: null,
              v4: null,
              v5: null
            }
          },
          fill: {
            final: {
              a1: null
            },
            options: {}
          }
        }
      }
    }
  },
  components: {
    quillEditor,
    Prism,
    vSelect,
    flatPickr
  },
  watch: {
    subject: function (newValue, oldValue) {
      this.group.class = [];
      if (newValue) {
        this.$http.get('/lms/st/task/question', { params: { class: newValue.class_id, subj: newValue.subj_id, rank: newValue.rank }}).then((response) => {
          if (response && response.data && response.data.data) {
            this.data.questions = response.data.data
            this.checkedQuestion = {}
            this.checkedCount = 0
          }
        }).catch((error) => {
          console.log(error)
        })
      }
    }
  },

  created () {
    this.$http.get('/lms/st/academics/subject/assigned').then((response) => {
      if (response && response.data && response.data.data) {
        const tracker = { subj: {}, class: {} }

        response.data.data.forEach((v) => {
          const subjKey = parseInt(`${v.subj_id}${v.rank.toString().slice(0, 2)}`)

          if (!tracker.subj[subjKey]) {
            this.data.subject.push({ subj_id: v.subj_id, rank: v.rank, class_id: v.class_id, subj: v.subj_short, class: v.class_short, label: `${v.class_short.slice(0, 3)} - ${v.name}` })
          }

          if (!tracker.class[`${v.class_id}-${v.subj_id}`]) {
            this.data.classes[v.subj_id] = this.data.classes[v.subj_id] || {}
            const rank = v.rank.toString().slice(0, 2)
            this.data.classes[v.subj_id][rank] = this.data.classes[v.subj_id][rank] || []
            this.data.classes[v.subj_id][rank].push({ class: v.class_name, subj: v.subj_id, class_id: v.class_id, rank: v.rank })
          }

          tracker.class[v.class_id] = 1
          tracker.subj[subjKey] = 1
        })
      }
    }).catch((error) => { 
      console.log(error)
    })
  },
  methods: {
    selectQuestion (question) {
      const c = {
        ...this.checkedQuestion
      }
      const cm = {
        ...this.checkedMarks
      }

      if (c[question.id]) {
        delete c[question.id]
        delete cm[question.id]
      } else {
        c[question.id] = question
        cm[question.id] = null
      }

      this.checkedCount = Object.keys(c).length
      this.checkedMarks = cm
      this.checkedQuestion = c
    },


    saveQuiz () {
      const quizSelection = {}

      if (this.checkedCount === 0) {
        return this.$vs.notify({ color: 'danger', title: 'No Question', text: 'Add questions from the bank' })
      }

      if (!this.group.class) {
        return this.$vs.notify({ color: 'danger', title: 'No Class', text: 'Select the Classes taking this Quiz' })
      }

      if (!this.group.type) {
        return this.$vs.notify({ color: 'danger', title: 'No Type', text: 'Select a Quiz type' })
      }

      if (!this.group.duration) {
        return this.$vs.notify({ color: 'danger', title: 'No Duration', text: 'Select a duration for the Quiz' })
      }

      if (!this.group.duedate) {
        return this.$vs.notify({ color: 'danger', title: 'No Due Date', text: 'Select a submission of due date for the Quiz' })
      }

      for (const x in this.checkedQuestion) {
        quizSelection[this.checkedQuestion[x].id] = this.checkedMarks[x]
      }


      const quizObject = {
        class: this.group.class,
        subj_id: this.subject.subj_id,
        quiz: quizSelection,
        title: this.group.title,
        duedate: this.group.duedate,
        i: this.group.instructions,
        t: this.group.type.type,
        d: this.group.duration.duration
      }

      this.$vs.loading()
      this.$http.post('/lms/st/task/quiz', quizObject).then((response) => {
        this.$vs.loading.close()
        if (response && response.data && response.data.data) {
          this.$vs.notify({ color: 'success', title: 'Upload Success', text: 'Quiz uploaded' })
          this.subject = null
          this.data.questions = []
          this.checkedQuestion = {}
          this.checkedCount = 0
          this.group.instructions = null
          this.group.type = null
          this.group.duration = null
          this.group.title = null
          this.group.duedate = null
          this.$router.push('/task/personal')
        } else {
          this.$vs.notify({ color: 'warning', title: 'Seems there is a Problem', text: 'Check saved Quiz' })
        }
      }).catch((error) => { 
        this.$vs.loading.close()
        console.log(error)
      })
    },

  }
}
</script>


<style scoped>
.optionlist {
  list-style: outside;
  list-style-type: decimal;
}

.optionlist2 {
  list-style: outside;
  list-style-type: dot;
}

.optionlist li {
  margin: 10px;
}

input.oinputx {
  width: 100%;
  padding-left: 5px;
  font-size: 15px;
  background: transparent;
  border: none;
  border-bottom: 1px solid #ddd;
}

.question {
  border-left: 4px solid #fff;
}

.selectedQuestion {
  border-left: 4px solid #7367F0;
}

.choseQuestion  {
  border-left: 4px solid #28C76F;
}
</style>